export default {

  state: () => ({
    contactId: undefined,
    sas: undefined
  }),

  getters: {
    contactId: (state) => {
      return state.contactId
    },
    sas: (state) => {
      return state.sas
    },
    sasId: (state) => {
      return state.sas.id
    }
  },
  mutations: {
    SET_CONTACTID(state, contactId) {
      state.contactId = contactId
    },

    SET_SAS(state, sas) {
      state.sas = sas
    }
  }
}